<template>
  <div id="cards">
    <dv-border-box-10 class="catdsBox">
      <div class="boxBorder">
        <div
          class="card-item"
          v-for="(item, index) in workshop1"
          :key="index"
          v-if="index < 5"
        >
          <dv-border-box-1 class="catdsBoxc">
            <div class="boxBorderc">
              <div class="card-header">
                <div class="card-header-left">{{ item.title }}</div>
                <div class="card-header-right">{{ '0' + (index + 1) }}</div>
              </div>
              <div class="mainConter">
                <div class="conterLeft">
                  <div class="userInfoBox">
                    <div class="userImgBox">
                      <dv-border-box-8 class="borderBox8">
                        <img class="userImg" :src="item.img" alt="" />
                      </dv-border-box-8>
                    </div>
                    <div class="info">
                      <div class="infoD">
                        <i class="iconfont icon-guanliyuan_jiaoseguanli"></i
                        >{{ item.userName }}
                      </div>
                      <div class="infoD">{{ item.userId }}</div>
                    </div>
                  </div>
                  <div class="userInfoBox">
                    <div class="statistics">
                      <div class="statisticsList">
                        <div class="footer-title">在职人数</div>
                        <div class="footer-detail">
                          <dv-digital-flop
                            :config="item.num"
                            style="width: 100%; height: 30px"
                          />
                          <div class="detail">人</div>
                        </div>
                      </div>
                      <div class="statisticsList">
                        <div class="footer-title">作业人数</div>
                        <div class="footer-detail">
                          <dv-digital-flop
                            :config="item.total"
                            style="width: 100%; height: 30px"
                          />
                          <div class="detail">人</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="conterRight">
                  <div class="rightTop">
                    <dv-charts class="ring-charts" :option="item.ring" />
                  </div>
                  <div class="tightBontm">
                    <dv-scroll-board
                      :config="item.ring1"
                      style="width: 100%; height: 110px"
                    />
                  </div>
                </div>
              </div>
              <dv-scroll-board
                :config="item.submitData"
                style="height: 40px; margin-left: 10px"
              />
            </div>
          </dv-border-box-1>
        </div>
      </div>
    </dv-border-box-10>
  </div>
</template>

<script>
import testWorkshop from '../../assets/json/workshop.json'
export default {
  name: 'workshop',
  props: {
    countData: {
      type: Object,
      default: function () {
        return {
          total: {
            employeeCount: 0,
            departmentCount: 0,
            processCount: 0,
            productCount: 0,
            taskCount: 0,
            completedCount: 0,
            smartDeviceCount: 0,
            rawMaterialCount: 0,
            videoCount: 0
          },
          rawMaterialStatistics: [],
          packageRawMaterialStatistics: [],
          packageRawMaterialStockCount: 0,
          packageRawMaterialInCount: 0,
          packageRawMaterialOutCount: 0,
          productStatistics: [],
          productStockCount: 0,
          productTodayInCount: 0,
          productTodayOutCount: 0,
          productionDepartmentStatistics: [
            {
              admin: {
                name: '高包平',
                photo:
                  'https://dfyd.5any.cn/Upload/2024/09/06/587445189288005.jpg'
              },
              departmentEmployeeCount: 0,
              departmentEmployeeWorkCount: 0,
              processList: [],
              semiFinishedProductList: []
            },
            {
              admin: {
                name: '胥锦文',
                photo:
                  'https://dfyd.5any.cn/Upload/2024/09/09/588564253909061.jpg'
              },
              departmentEmployeeCount: 0,
              departmentEmployeeWorkCount: 0,
              processList: [],
              semiFinishedProductList: []
            },
            {
              admin: {
                name: '揭希元',
                photo:
                  'https://dfyd.5any.cn/Upload/2024/09/06/587472038178885.jpg'
              },
              departmentEmployeeCount: 0,
              departmentEmployeeWorkCount: 0,
              processList: [],
              semiFinishedProductList: []
            },
            {
              admin: {
                name: '古国斌',
                photo:
                  'https://dfyd.5any.cn/Upload/2024/09/07/587822216728645.jpg'
              },
              departmentEmployeeCount: 0,
              departmentEmployeeWorkCount: 0,
              processList: [],
              semiFinishedProductList: []
            },
            {
              admin: {
                name: '陈木兰',
                photo: ''
              },
              departmentEmployeeCount: 0,
              departmentEmployeeWorkCount: 0,
              processList: [],
              semiFinishedProductList: []
            }
          ]
        }
      },
      require: true
    }
  },
  data() {
    return {
      workshop: {}
    }
  },
  computed: {
    workshop1: function () {
      const { randomExtend } = this
      var list = this.countData.productionDepartmentStatistics.map((x) => {
        var semiFinishedProductList = x.semiFinishedProductList.map((y) => [
          `${y.employee} 提交了 ${y.name} ${y.submitCount} ${y.unit}`
        ])

        var processList = x.processList.map((y) => [y.name, `${y.percent}%`])
        var taskTotalList = x.processList.map((y) => y.taskTotal)
        var taskNameList = x.processList.map((y) => y.name)
        var taskFinishedList = x.processList.map((y) => y.taskFinished)

        var photo = x.admin.photo

        if (photo) {
          if (photo.indexOf('http://') >= 0 || photo.indexOf('https://') >= 0) {
          } else {
            photo = 'https://xfhp.5any.cn/' + photo
          }
        }

        return {
          title: x.name,
          userName: x.admin.name,
          userId: x.admin.code,
          img: photo
            ? photo
            : require('../../assets/img/6.png'),
          total: {
            number: [x.departmentEmployeeWorkCount],
            content: '{nt}',
            textAlign: 'right',
            style: {
              fill: '#26fcd8',
              fontWeight: 'bold',
              fontSize: 20
            }
          },
          num: {
            number: [x.departmentEmployeeCount],
            content: '{nt}',
            textAlign: 'right',
            style: {
              fill: '#4d99fc',
              fontWeight: 'bold',
              fontSize: 20
            }
          },
          submitData: {
            data: semiFinishedProductList,
            waitTime: 7000,
            rowNum: 1,
            oddRowBGC: 'rgba(255, 255, 255, 0)',
            evenRowBGC: 'rgba(255, 255, 255, 0)'
          },
          ring: {
            grid: {
              left: 20,
              right: 20,
              top: '5%',
              bottom: '5%'
            },
            xAxis: {
              data: ['', '', '', '', '', ''],
              axisTick: {
                show: false
              },
              axisLine: {
                show: false
              },
              axisLabel: {
                show: false
              }
            },
            yAxis: {
              data: 'value',
              axisTick: {
                show: false
              },
              axisLine: {
                show: false
              },
              axisLabel: {
                show: false
              },
              splitLine: {
                show: false
              }
            },
            series: [
              {
                type: 'bar',
                data: taskTotalList,
                stack: 'a',
                label: {
                  show: true,
                  position: 'center',
                  offset: [0, 0],
                  style: {
                    fill: '#fff'
                  }
                },
                backgroundBar: {
                  show: true
                },
                animationCurve: 'easeOutBounce'
              },
              {
                name: '',
                data: [taskFinishedList],
                type: 'bar',
                stack: 'a',
                label: {
                  show: true,
                  position: 'center',
                  offset: [0, 0],
                  style: {
                    fill: '#fff'
                  }
                },
                backgroundBar: {
                  show: true
                },
                animationCurve: 'easeOutBounce'
              }
            ]
          },
          ring1: {
            data: processList,
            index: true,
            waitTime: 7000,
            rowNum: 5,
            columnWidth: [34, 110],
            headerHeight: 15
          }
        }
      })
      return list
    }
  },
  mounted() {
    const { createData } = this
    createData()
    setInterval(this.createData, 30000)
  },
  methods: {
    createData() {
      const { randomExtend } = this
      this.workshop = [
        {
          title: '制筒车间',
          userName: '黄小平',
          userId: '1001',
          img: require('../../assets/img/1.png'),
          total: {
            number: [randomExtend(0, 0)],
            content: '{nt}',
            textAlign: 'right',
            style: {
              fill: '#26fcd8',
              fontWeight: 'bold',
              fontSize: 20
            }
          },
          num: {
            number: [randomExtend(20, 30)],
            content: '{nt}',
            textAlign: 'right',
            style: {
              fill: '#4d99fc',
              fontWeight: 'bold',
              fontSize: 20
            }
          },
          submitData: {
            data: [
              ['黄小平提交了 60#围箍纸筒10大箍 '],
              ['宋正香提交了 70#围箍纸筒10大箍 ']
            ],
            waitTime: 7000,
            rowNum: 1,
            oddRowBGC: 'rgba(255, 255, 255, 0)',
            evenRowBGC: 'rgba(255, 255, 255, 0)'
          },
          ring: {
            grid: {
              left: 20,
              right: 20,
              top: '5%',
              bottom: '5%'
            },
            xAxis: {
              data: ['周一', '周二', '周三', '周四', '周五', '周六'],
              axisTick: {
                show: false
              },
              axisLine: {
                show: false
              },
              axisLabel: {
                show: false
              }
            },
            yAxis: {
              data: 'value',
              axisTick: {
                show: false
              },
              axisLine: {
                show: false
              },
              axisLabel: {
                show: false
              },
              splitLine: {
                show: false
              }
            },
            series: [
              {
                type: 'bar',
                data: [50, 40, 30, 70],
                stack: 'a',
                label: {
                  show: true,
                  position: 'center',
                  offset: [0, 0],
                  style: {
                    fill: '#fff'
                  }
                },
                backgroundBar: {
                  show: true
                },
                animationCurve: 'easeOutBounce'
              },
              {
                name: '',
                data: [70, 40, 10, 70],
                type: 'bar',
                stack: 'a',
                label: {
                  show: true,
                  position: 'center',
                  offset: [0, 0],
                  style: {
                    fill: '#fff'
                  }
                },
                backgroundBar: {
                  show: true
                },
                animationCurve: 'easeOutBounce'
              }
            ]
          },
          ring1: {
            data: [
              ['切纸', '20%'],
              ['制筒', '40%'],
              ['围箍', '50%'],
              ['打底切筒', '70%'],
              ['', '']
            ],
            index: true,
            waitTime: 7000,
            rowNum: 5,
            columnWidth: [34, 110],
            headerHeight: 15
          }
        },
        {
          title: '注引车间',
          userName: '宋正香',
          userId: '1002',
          img: require('../../assets/img/2.png'),

          total: {
            number: [randomExtend(0, 0)],
            content: '{nt}',
            textAlign: 'right',
            style: {
              fill: '#26fcd8',
              fontWeight: 'bold',
              fontSize: 20
            }
          },
          num: {
            number: [randomExtend(26, 60)],
            content: '{nt}',
            textAlign: 'right',
            style: {
              fill: '#4d99fc',
              fontWeight: 'bold',
              fontSize: 20
            }
          },
          submitData: {
            data: [
              ['黄林生 提交了 60#空筒199墩 '],
              ['胥小荣 提交了 70#空筒89墩 '],
              ['王新兰 提交了 60#干饼19篓 ']
            ],
            waitTime: 7000,
            rowNum: 1,
            oddRowBGC: 'rgba(255, 255, 255, 0)',
            evenRowBGC: 'rgba(255, 255, 255, 0)'
          },
          ring: {
            grid: {
              left: 20,
              right: 20,
              top: '5%',
              bottom: '5%'
            },
            xAxis: {
              data: ['周一', '周二', '周三', '周四', '周五', '周六'],
              axisTick: {
                show: false
              },
              axisLine: {
                show: false
              },
              axisLabel: {
                show: false
              }
            },
            yAxis: {
              data: 'value',
              axisTick: {
                show: false
              },
              axisLine: {
                show: false
              },
              axisLabel: {
                show: false
              },
              splitLine: {
                show: false
              }
            },
            series: [
              {
                type: 'bar',
                data: [70, 10, 50, 50, 72, 57],
                stack: 'a',
                label: {
                  show: true,
                  position: 'center',
                  offset: [0, 0],
                  style: {
                    fill: '#fff'
                  }
                },
                backgroundBar: {
                  show: true
                },
                animationCurve: 'easeOutBounce'
              },
              {
                name: '',
                data: [50, 80, 40, 60, 42, 72],
                type: 'bar',
                stack: 'a',
                label: {
                  show: true,
                  position: 'center',
                  offset: [0, 0],
                  style: {
                    fill: '#fff'
                  }
                },
                backgroundBar: {
                  show: true
                }
                // animationCurve: 'easeOutBounce'
              }
            ]
          },
          ring1: {
            data: [
              ['空筒至注引车间', '20%'],
              ['注引药拌料', '40%'],
              [' 注引', '50%'],
              ['注引空筒中转进烘房 ', '90%'],
              ['注引空筒中转出烘房', '50%'],
              ['烘房运至一体机', '82%']
            ],
            index: true,
            waitTime: 7000,
            rowNum: 5,
            columnWidth: [34, 110],
            headerHeight: 15
          }
        },
        {
          title: '一体机车间',
          userName: '黄乐',
          userId: '1003',
          img: require('../../assets/img/3.png'),

          total: {
            number: [randomExtend(0, 0)],
            content: '{nt}',
            textAlign: 'right',
            style: {
              fill: '#26fcd8',
              fontWeight: 'bold',
              fontSize: 20
            }
          },
          num: {
            number: [randomExtend(5, 6)],
            content: '{nt}',
            textAlign: 'right',
            style: {
              fill: '#4d99fc',
              fontWeight: 'bold',
              fontSize: 20
            }
          },
          submitData: {
            data: [
              ['龙小红 提交了 60#干饼(待配药)29篓 '],
              ['胥锦文 提交了 70#干饼(待配药)39篓 ']
            ],
            waitTime: 7000,
            rowNum: 1,
            oddRowBGC: 'rgba(255, 255, 255, 0)',
            evenRowBGC: 'rgba(255, 255, 255, 0)'
          },
          ring: {
            grid: {
              left: 20,
              right: 20,
              top: '5%',
              bottom: '5%'
            },
            xAxis: {
              data: ['周一', '周二', '周三', '周四', '周五', '周六'],
              axisTick: {
                show: false
              },
              axisLine: {
                show: false
              },
              axisLabel: {
                show: false
              }
            },
            yAxis: {
              data: 'value',
              axisTick: {
                show: false
              },
              axisLine: {
                show: false
              },
              axisLabel: {
                show: false
              },
              splitLine: {
                show: false
              }
            },
            series: [
              {
                type: 'bar',
                data: [40, 20, 40, 20],
                stack: 'a',
                label: {
                  show: true,
                  position: 'center',
                  offset: [0, 0],
                  style: {
                    fill: '#fff'
                  }
                },
                backgroundBar: {
                  show: true
                },
                animationCurve: 'easeOutBounce'
              },
              {
                name: '',
                data: [60, 80, 30, 70],
                type: 'bar',
                stack: 'a',
                label: {
                  show: true,
                  position: 'center',
                  offset: [0, 0],
                  style: {
                    fill: '#fff'
                  }
                },
                backgroundBar: {
                  show: true
                }
                // animationCurve: 'easeOutBounce'
              }
            ]
          },
          ring1: {
            data: [
              ['送饼', '70%'],
              ['装配药', '80%'],
              ['收饼', '50%'],
              ['硝饼进中转库', '70%'],
              ['', '']
            ],
            index: true,
            waitTime: 7000,
            rowNum: 5,
            columnWidth: [34, 110],
            headerHeight: 15
          }
        },
        {
          title: '机械排鞭车间',
          userName: '龙启丽',
          userId: '1004',
          img: require('../../assets/img/4.png'),

          total: {
            number: [randomExtend(0, 0)],
            content: '{nt}',
            textAlign: 'right',
            style: {
              fill: '#26fcd8',
              fontWeight: 'bold',
              fontSize: 20
            }
          },
          num: {
            number: [randomExtend(40, 46)],
            content: '{nt}',
            textAlign: 'right',
            style: {
              fill: '#4d99fc',
              fontWeight: 'bold',
              fontSize: 20
            }
          },
          submitData: {
            data: [
              ['龙英 提交了 60硝饼20篓 '],
              ['杨双敏 提交了 机械排鞭(鄂州LD22)27件'],
              ['朱海容 提交了 机械排鞭(鄂州LD32)13件']
            ],
            waitTime: 7000,
            rowNum: 1,
            oddRowBGC: 'rgba(255, 255, 255, 0)',
            evenRowBGC: 'rgba(255, 255, 255, 0)'
          },
          ring: {
            grid: {
              left: 20,
              right: 20,
              top: '5%',
              bottom: '5%'
            },
            xAxis: {
              data: ['周一', '周二', '周三', '周四', '周五', '周六'],
              axisTick: {
                show: false
              },
              axisLine: {
                show: false
              },
              axisLabel: {
                show: false
              }
            },
            yAxis: {
              data: 'value',
              axisTick: {
                show: false
              },
              axisLine: {
                show: false
              },
              axisLabel: {
                show: false
              },
              splitLine: {
                show: false
              }
            },
            series: [
              {
                type: 'bar',
                data: [70, 40],
                stack: 'a',
                label: {
                  show: true,
                  position: 'center',
                  offset: [0, 0],
                  style: {
                    fill: '#fff'
                  }
                },
                backgroundBar: {
                  show: true
                },
                animationCurve: 'easeOutBounce'
              },
              {
                name: '',
                data: [60, 30],
                type: 'bar',
                stack: 'a',
                label: {
                  show: true,
                  position: 'center',
                  offset: [0, 0],
                  style: {
                    fill: '#fff'
                  }
                },
                backgroundBar: {
                  show: true
                }
                // animationCurve: 'easeOutBounce'
              }
            ]
          },
          ring1: {
            data: [
              ['硝饼中转结鞭', '60%'],
              ['机械排鞭', '80%'],
              ['', ''],
              ['', ''],
              ['', '']
            ],
            index: true,
            waitTime: 7000,
            rowNum: 5,
            columnWidth: [34, 110],
            headerHeight: 15
          }
        },
        {
          title: '封装车间',
          userName: '王斌',
          userId: '1005',
          img: require('../../assets/img/5.png'),
          total: {
            number: [randomExtend(0, 0)],
            content: '{nt}',
            textAlign: 'right',
            style: {
              fill: '#26fcd8',
              fontWeight: 'bold',
              fontSize: 20
            }
          },
          num: {
            number: [randomExtend(10, 14)],
            content: '{nt}',
            textAlign: 'right',
            style: {
              fill: '#4d99fc',
              fontWeight: 'bold',
              fontSize: 20
            }
          },
          submitData: {
            data: [
              ['胡水妹 提交了 (利川LD31加密加厚)20件'],
              ['杨双敏 提交了 (来凤LD22)42件']
            ],
            waitTime: 7000,
            rowNum: 1,
            oddRowBGC: 'rgba(255, 255, 255, 0)',
            evenRowBGC: 'rgba(255, 255, 255, 0)'
          },
          ring: {
            grid: {
              left: 20,
              right: 20,
              top: '5%',
              bottom: '5%'
            },
            xAxis: {
              data: ['周一', '周二', '周三', '周四', '周五', '周六'],
              axisTick: {
                show: false
              },
              axisLine: {
                show: false
              },
              axisLabel: {
                show: false
              }
            },
            yAxis: {
              data: 'value',
              axisTick: {
                show: false
              },
              axisLine: {
                show: false
              },
              axisLabel: {
                show: false
              },
              splitLine: {
                show: false
              }
            },
            series: [
              {
                type: 'bar',
                data: [40, 60, 50],
                stack: 'a',
                label: {
                  show: true,
                  position: 'center',
                  offset: [0, 0],
                  style: {
                    fill: '#fff'
                  }
                },
                backgroundBar: {
                  show: true
                },
                animationCurve: 'easeOutBounce'
              },
              {
                name: '',
                data: [60, 40, 70],
                type: 'bar',
                stack: 'a',
                label: {
                  show: true,
                  position: 'center',
                  offset: [0, 0],
                  style: {
                    fill: '#fff'
                  }
                },
                backgroundBar: {
                  show: true
                }
                // animationCurve: 'easeOutBounce'
              }
            ]
          },
          ring1: {
            data: [
              ['封装', '60%'],
              ['打包', '70%'],
              [' 进仓', '50%'],
              ['', ''],
              ['', '']
            ],
            index: true,
            waitTime: 7000,
            rowNum: 5,
            columnWidth: [34, 110],
            headerHeight: 15
          }
        }
      ]
    },
    randomExtend(minNum, maxNum) {
      if (arguments.length === 1) {
        return parseInt(Math.random() * minNum + 1, 10)
      } else {
        return parseInt(Math.random() * (maxNum - minNum + 1) + minNum, 10)
      }
    }
  }
}
</script>

<style lang="less">
#cards {
  height: 45%;

  .catdsBox {
    box-sizing: border-box;

    .boxBorder {
      height: 100%;
      box-sizing: border-box;
      padding: 10px 10px;
      display: flex;
      justify-content: space-around;

      .card-item {
        background-color: rgba(6, 30, 93, 0.5);
        width: 19%;
        border-radius: 10%;

        .catdsBoxc {
          box-sizing: border-box;

          .boxBorderc {
            height: 100%;
            box-sizing: border-box;
            padding: 0 8px 6px 6px;
            display: flex;
            flex-direction: column;

            .card-header {
              display: flex;
              height: 20%;
              align-items: center;
              justify-content: space-between;

              .card-header-left {
                font-size: 18px;
                font-weight: 800;
                padding-left: 20px;
              }

              .card-header-right {
                padding-right: 15px;
                font-size: 32px;
                font-weight: 700;
                color: #03d3ec;
              }
            }
          }

          .mainConter {
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: row;
            align-content: center;
            .conterLeft {
              width: 30%;
              height: 100%;
              .userInfoBox {
                height: 50%;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: space-around;
                border-bottom: 2px solid rgba(1, 153, 209, 0.5);
                .icon-guanliyuan_jiaoseguanli {
                  margin-right: 5px;
                }
                .userImgBox {
                  .borderBox8 {
                    width: 80px;
                    height: 100px;
                    padding: 5px;
                    box-sizing: border-box;
                    .userImg {
                      width: 100%;
                      height: 100%;
                    }
                  }
                }

                .statistics {
                  .statisticsList {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    .footer-title {
                      font-size: 14px;
                      font-weight: 700;
                    }
                    .footer-detail {
                      margin-left: -20px;
                      display: flex;
                      flex-direction: row;
                      align-items: center;
                      .detail {
                        font-size: 18px;
                      }
                    }
                  }
                }
                .userTitle {
                  font-size: 15px;
                  font-weight: 700;
                }

                .userImg {
                  width: 70px;
                }

                .info {
                  font-size: 15px;
                  font-weight: 700;
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                  justify-content: space-between;
                }
              }
            }
            .conterRight {
              width: 70%;
              display: flex;
              flex-direction: column;
              justify-content: space-between;

              .rightTop {
                margin-top: -3%;
                margin-right: -60px;

                .ring-charts {
                  width: 200px;
                  height: 150px;
                }
              }
              .tightBontm {
                width: 100%;
              }
            }
          }
        }
      }
    }
  }
}
</style>
